export default __webpack_public_path__ + "static/media/goopter-restaurant-automation.47bf7b82.jpg";